import React from 'react';
import { motion } from 'framer-motion';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
export function FinalCTASection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-brand-dark text-white py-24 px-4 relative overflow-hidden border-t border-brand-border" data-id="element-90">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-91">
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-accent/3 rounded-full blur-[150px]" data-id="element-92"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-93">
        <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-sm uppercase mb-6" data-id="element-94">
          <span className="text-xl" data-id="element-95">🔬</span> PROFEPACK
        </div>

        <motion.p className="text-xl md:text-2xl text-white/60 mb-4 italic" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-96">
          El próximo domingo podés seguir buscando actividades en Google.
        </motion.p>
        <motion.p className="text-2xl md:text-3xl font-heading font-bold text-brand-accent mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} data-id="element-97">
          O podés tener todo resuelto desde hoy.
        </motion.p>

        {/* Countdown */}
        <motion.div className="mb-12" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-98">
          <CountdownTimer data-id="element-99" />
        </motion.div>

        {/* 3-column pricing summary */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-16 max-w-3xl mx-auto" data-id="element-100">
          <div className="bg-brand-card p-5 rounded-2xl border border-brand-border flex flex-col items-center justify-between" data-id="element-101">
            <div className="font-bold text-white/40 mb-2 text-sm" data-id="element-102">
              ⚡ FÍSICA
            </div>
            <div className="text-2xl font-heading font-bold text-white mb-4" data-id="element-103">
              $19.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48097185071360:1', '_blank')} className="w-full bg-brand-accent/10 border border-brand-accent/30 hover:bg-brand-accent/20 text-brand-accent py-3 rounded-2xl text-sm font-black transition-colors" data-id="element-104">
              → QUIERO FÍSICA
            </button>
          </div>

          <div className="bg-brand-card p-5 rounded-2xl border-2 border-brand-accent flex flex-col items-center justify-between transform md:scale-105 z-10 shadow-[0_0_30px_rgba(0,255,133,0.1)]" data-id="element-105">
            <div className="font-bold text-brand-accent mb-2 text-sm" data-id="element-106">
              🏆 PACK COMPLETO ⭐
            </div>
            <div className="text-3xl font-heading font-bold text-brand-accent mb-4" data-id="element-107">
              $29.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48108607242496:1', '_blank')} className="w-full bg-brand-accent hover:bg-brand-accent-dim text-brand-dark py-3 rounded-2xl text-sm font-black transition-colors" data-id="element-108">
              → QUIERO MI MEGAPACK
            </button>
          </div>

          <div className="bg-brand-card p-5 rounded-2xl border border-brand-border flex flex-col items-center justify-between" data-id="element-109">
            <div className="font-bold text-white/40 mb-2 text-sm" data-id="element-110">
              🧪 QUÍMICA
            </div>
            <div className="text-2xl font-heading font-bold text-white mb-4" data-id="element-111">
              $19.990 ARS
            </div>
            <button onClick={() => window.open('https://www.profepack.com/cart/48097186545920:1', '_blank')} className="w-full bg-brand-accent/10 border border-brand-accent/30 hover:bg-brand-accent/20 text-brand-accent py-3 rounded-2xl text-sm font-black transition-colors" data-id="element-112">
              → QUIERO QUÍMICA
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-6 md:gap-10 text-white/40 font-medium mb-16 text-sm" data-id="element-113">
          <div className="flex items-center gap-2" data-id="element-114">
            <Lock size={18} className="text-brand-accent" data-id="element-115" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-116">
            <Zap size={18} className="text-brand-accent" data-id="element-117" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-118">
            <ShieldCheck size={18} className="text-brand-accent" data-id="element-119" /> Garantía 7
            días sin preguntas
          </div>
          <div className="flex items-center gap-2" data-id="element-120">
            <CreditCard size={18} className="text-brand-accent" data-id="element-121" /> Mercado Pago
            | Tarjeta | Transferencia
          </div>
        </div>

        <div className="border-t border-brand-border pt-12 max-w-2xl mx-auto" data-id="element-122">
          <div className="flex items-center justify-center gap-2 text-brand-accent font-badge font-bold tracking-widest text-xs uppercase mb-4" data-id="element-123">
            🔬 PROFEPACK
          </div>
          <p className="text-white/40 italic mb-2 text-sm" data-id="element-124">
            El sistema de planificación científica N°1 para docentes de Física y
            Química de secundaria en Argentina.
          </p>
          <p className="text-white/40 italic text-sm" data-id="element-125">
            Porque enseñar ciencias no debería costarte todos los domingos del
            año.
          </p>
        </div>
      </div>
    </section>;
}